import { render } from "./CreateCaracterisation.vue?vue&type=template&id=210b9819"
import script from "./CreateCaracterisation.vue?vue&type=script&lang=js"
export * from "./CreateCaracterisation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__